// 中身から画面への知らせ（2026-10-23〜）。中身は画面の部品を呼ばず、変わったことだけを知らせる。
// 画面（新しい作る画面・クラシック版）は on で受けて、自分の部品を合わせる
//   placed  1カテゴリの位置・反転・回転・うすさを付け直した（描き直しの途中も。新しい画面は枠の描き直しとオートセーブ）
//   drawn   1カテゴリを描き直し終えた（パーツ・位置・色・柄。メーカーごとの後処理を足す所）
//   drawnAll 全部のカテゴリを描き直し終えた（renderAll。読み込み・ランダム・元に戻す。メーカーごとの後処理を最後に 1 回だけ掛ける所）
//   applied 保存データを読んで全部描き直した（新しい画面は名前を描き直す）
import type { Category, PartState } from '../types.js';
import type { Why } from './model.js';

export interface CoreEvents {
  placed: (cat: Category, st: PartState, why: Why) => void;
  drawn: (cat: Category, st: PartState, why: Why) => void;
  drawnAll: (why: Why) => void;
  applied: () => void;
}
type Listener = (...args: never[]) => void;
const subs: Partial<Record<keyof CoreEvents, Listener[]>> = {};

export function on<K extends keyof CoreEvents>(name: K, fn: CoreEvents[K]) {
  const list: Listener[] = subs[name] || (subs[name] = []);
  list.push(fn as Listener);
}
export function emit<K extends keyof CoreEvents>(name: K, ...args: Parameters<CoreEvents[K]>) {
  (subs[name] || []).forEach((fn) => { (fn as unknown as (...a: Parameters<CoreEvents[K]>) => void)(...args); });
}
